import { Component, Input, OnDestroy, OnInit, inject, input } from '@angular/core';
import { CmmsFiltersService } from '@app/pages/cmms/components/cmms-sort-filters-grouping/services/cmms-filters.service';
import { map, takeUntil } from 'rxjs/operators';
import { ICmmsSelectedFilter } from '@app/pages/cmms/components/cmms-sort-filters-grouping/interfaces-and-types/filter.interfaces';
import { Subject, combineLatest } from 'rxjs';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';
import { IIncident } from '@app/pages/cmms/interfaces/incidents.interface';
import { IRequest } from '@app/pages/cmms/interfaces/request.interfaces';
import { ICmmsAsset } from '@app/pages/cmms/interfaces/assets.interfaces';

import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { SearchBarComponent } from '@app/pages/cmms/components/cmms-sort-filters-grouping/search-bar/search-bar.component';
import { FilterListMenuComponent } from '@app/pages/cmms/components/cmms-sort-filters-grouping/filter-list-menu/filter-list-menu.component';
import { Store } from '@ngrx/store';
import { getCurrentBuildingId } from '@app/pages/my-building/state/my-bulding.selectors';
import { MatButtonModule } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { IWorkOrder } from '@app/domain/cmms-types/workorder-types';
@Component({
	selector: 'cmms-applied-filters-bar',
	templateUrl: './cmms-applied-filters-bar.component.html',
	styleUrls: ['./cmms-applied-filters-bar.component.scss'],
	imports: [
		MatMenuModule,
		MatIconModule,
		SearchBarComponent,
		FilterListMenuComponent,
		MatButtonModule,
		NgxTolgeeModule,
	],
})
export class CmmsAppliedFiltersBarComponent implements OnInit, OnDestroy {
	private readonly store$ = inject(Store);
	@Input() activePage: CmmsPages;
	@Input() currentEntity:
		| ICmmsAsset[]
		| IWorkOrder[]
		| IRequest[]
		| IIncident[]
		| IFileEntity[];

	selectedFilters: ICmmsSelectedFilter[] = [];

	private destroy$ = new Subject<void>();

	filtersSelected = input<boolean>(false);
	constructor(private filterService: CmmsFiltersService) {}

	ngOnInit(): void {
		this.subscribeToSelectedFilters();
	}

	subscribeToSelectedFilters(): void {
		combineLatest([
			this.filterService.selectedFilters$,
			this.store$.select(getCurrentBuildingId),
		])
			.pipe(
				takeUntil(this.destroy$),
				map(([selectedFilters, buildingId]) =>
					setLocationFilter(selectedFilters, buildingId)
				)
			)
			.subscribe(selectedFilters => {
				this.selectedFilters = selectedFilters;
			});
	}

	clearFilters(): void {
		this.filterService.clearAllFilters();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}

function setLocationFilter(
	filters: ICmmsSelectedFilter[],
	selectedBuildingId: string | undefined
): ICmmsSelectedFilter[] {
	if (selectedBuildingId == null) {
		return filters;
	}

	return filters.map(filter => {
		if (filter.selectedFilter.type === 'location') {
			// Limit location options to the currently selected building
			const newSelected = {
				...filter.selectedFilter,
				options: {
					selectedBuildingId,
				},
			};
			return { ...filter, selectedFilter: newSelected };
		}
		return filter;
	});
}
